<template>
    <div>
        <template v-if="manage_meta_data === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">MetaData Configuration </h1>
                <router-link to="/addmanageMetaDataComponent" class="btn btn-primary active float-right"> Add New</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" companyName="" />
                </div>
            </div>
            <table id="manage_meta_data_table" class="table" width="100%">
                <thead>
                <tr>
                    <th>No</th>
                    <th>Key</th>
                    <th>Value</th>
                    <th>Comment</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th class="text-center">Action</th>
                </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="manage_meta_data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_meta_data === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                manage_meta_data: null
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var manage_meta_data_table = $('#manage_meta_data_table').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/metaDataList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    order: [[1, "asc"]],
                    columns: [
                        {data: 'id'},
                        {data: 'key'},
                        {data: 'value'},
                        {data: 'comment'},
                        {data: 'created_at',
                            render: function(data,type,full){
                                if(full.created_at != null){
                                    return moment(full.created_at).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {data: 'updated_at',
                            render: function(data,type,full){
                                if(full.updated_at != null){
                                    return moment(full.updated_at).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                                var $url = '/editmanageMetaDataComponent/'+full['id'];
                                return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                            }}
                    ],
                    "order": [[1, "asc"]],
                    "columnDefs": [
                        {
                            "targets": [ 0 ],
                            "visible": false,
                            "searchable": false
                        },
                        {
                            "targets": 3,
                            "render": function (data, type, row) {
                                return "<textarea class='lg-textarea form-control' rows='4' name='diagnosis' id='diagnosis' readonly>" + data + "</textarea>";
                            },
                        },
                        {
                            "targets": 2,
                            "render": function (data, type, row) {
                                return "<div class='w-0' style='max-width: 210px; white-space: normal ; word-wrap: break-word; text-overflow: ellipsis;' class='w-25' name='diagnosis' id='diagnosis' readonly>" + data + "</div>";
                            },
                        },
                        {
                            "targets": 1,
                            "render": function (data, type, row) {
                                return "<div class='w-0' style='max-width: 210px; white-space: normal ; word-wrap: break-word; text-overflow: ellipsis;' class='w-25' name='diagnosis' id='diagnosis' readonly>" + data + "</div>";
                            },
                        },
                        ],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        manage_meta_data_table.search(this.value).draw();
                    }
                });
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('manage_meta_data').then(result => {
                if(result.manage_meta_data == true)
                {
                    this.manage_meta_data = true;
                } else {
                    this.manage_meta_data = false;
                }
            }).then(result => {
                if(this.manage_meta_data == true){
                    this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
